export default [
    {
        "couponExplain": "<p>1. 在有效期内，凭此券在奈雪内地任意门店(机场店、奈雪梦工厂除外)及“奈雪点单”小程序免费兑换任意饮品或软欧包一份，菜单上标有红色雪花产品除外</p><p>2. 此券不可兑换现金，不设找零，优惠券抵扣金额不予积分</p><p>3. 此券每单仅限使用一张，不得与其他优惠券同时使用</p><p>4. 此券不适用于第三方外送服务</p><p>5. 券面图片仅供参考，产品以实物为准</p>",
        "discountUnit": 1,
        "imageUrl": "https://images.qmai.cn/s23107/2019/10/09/ea5b8ed493c0cc310d.jpg",
        "id": "1",
        "discountAmount": null,
        "beginAt": "2020-05-10 00:00:00",
        "useTimeScope": "[{\"begin\":\"00:00:00\",\"end\":\"23:59:59\"}]",
        "endAt": "2020-06-08 23:59:59",
        "createdAt": "2020-05-10 02:06:00",
        "title": "生日免费券",
        "couponId": "1",
        "deletedAt": null,
        "sellerName": "奈雪の茶",
        "updatedAt": "2020-05-10 02:06:00",
        "couponType": 1
    },
    {
        "couponExplain": "1. 适用商品：免费兑换生日特调鸡尾酒一杯\n2. 适用门店：仅限内地奈雪酒屋任意门店堂食使用\n3. 适用场景：线下门店出示会员码使用\n4. 本券仅限消费酒类产品，依法不支持未成年人使用\n5. 此券每单仅限使用一张，不可兑换现金，不设找零，优惠券抵扣金额不予积分\n6. 此券不适用于第三方外送服务\n7. 券面图片仅供参考，产品以实物为准",
        "discountUnit": null,
        "imageUrl": "https://images.qmai.cn/s34747/2019/12/04/5d97da76e82bfe26d3.png",
        "id": "2",
        "discountAmount": null,
        "beginAt": "2020-05-10 00:00:00",
        "useTimeScope": "[{\"begin\":\"00:00:00\",\"end\":\"23:59:59\"}]",
        "endAt": "2020-06-08 23:59:59",
        "createdAt": "2020-05-10 02:06:00",
        "title": "生日特调券",
        "couponId": "2",
        "deletedAt": null,
        "sellerName": "奈雪酒屋",
        "updatedAt": "2020-05-10 02:06:00",
        "couponType": 2
    },
    {
        "couponExplain": "1. 使用条件：在有效期内，免费兑换鸡尾酒一杯，每周五、周六与法定节假日19点后不支持使用\n2. 适用商品：鸡尾酒/红葡萄酒/白葡萄酒，具体以门店营业信息为准\n3. 适用门店：仅限内地奈雪酒屋任意门店堂食使用\n4. 适用场景：线下门店出示会员码使用\n5. 本券仅限消费酒类产品，依法不支持未成年人使用\n6. 此券每单仅限使用一张，不可兑换现金，不设找零，优惠券抵扣金额不予积分\n7. 此券不适用于第三方外送服务8. 券面图片仅供参考，产品以实物为准",
        "discountUnit": null,
        "imageUrl": "https://images.qmai.cn/s34747/2019/12/04/5d97da76e82bfe26d3.png",
        "id": "3",
        "discountAmount": null,
        "beginAt": "2020-05-08 00:00:00",
        "useTimeScope": "[{\"begin\":\"00:00:00\",\"end\":\"23:59:59\"}]",
        "endAt": "2020-06-06 23:59:59",
        "createdAt": "2020-05-08 19:25:41",
        "title": "酒屋特调券",
        "couponId": "3",
        "deletedAt": null,
        "sellerName": "奈雪酒屋",
        "updatedAt": "2020-05-08 19:25:41",
        "couponType": 2
    },
    {
        "couponExplain": "<p>1. 在有效期内，凭此券可在奈雪内地任意门店(机场店、奈雪梦工厂除外)及“奈雪点单”小程序购买任意茶饮一杯，可免费获得软欧包一个（价格不高于茶饮），菜单上标有红色雪花产品除外</p><p>2. 此券不可兑换现金，不设找零，优惠券抵扣金额不予积分</p><p>3. 此券每单仅限使用一张，不得与其他优惠券同时使用</p><p>4. 此券不适用于第三方外送服务</p><p>5. 券面图片仅供参考，产品以实物为准</p>",
        "discountUnit": 2,
        "imageUrl": "https://images.qmai.cn/s23107/2019/10/10/8a8be6ddf7a4140944.jpg",
        "id": "4",
        "discountAmount": 0,
        "beginAt": "2020-05-08 00:00:00",
        "useTimeScope": "[{\"begin\":\"00:00:00\",\"end\":\"23:59:59\"}]",
        "endAt": "2020-06-06 23:59:59",
        "createdAt": "2020-05-08 19:25:41",
        "title": "升级好友券",
        "couponId": "4",
        "deletedAt": null,
        "sellerName": "奈雪の茶",
        "updatedAt": "2020-05-08 19:25:41",
        "couponType": 1
    },
    {
        "couponExplain": "<p>1. 在有效期内，凭此券可在奈雪内地任意门店(机场店、奈雪梦工厂除外)及“奈雪点单”小程序享受购买任意茶饮满两杯赠一杯（赠送产品价格不高于购买产品），菜单上标有红色雪花产品除外</p><p>2. 此券不可兑换现金，不设找零，优惠券抵扣金额不予积分</p><p>3. 此券每单仅限使用一张，不得与其他优惠券同时使用</p><p>4. 此券不适用于第三方外送服务</p><p>5. 券面图片仅供参考，产品以实物为准</p>",
        "discountUnit": 2,
        "imageUrl": "https://images.qmai.cn/s23107/2019/10/09/ea5b8ed493c0cc310d.jpg",
        "id": "5",
        "discountAmount": 0,
        "beginAt": "2020-05-08 00:00:00",
        "useTimeScope": "[{\"begin\":\"00:00:00\",\"end\":\"23:59:59\"}]",
        "endAt": "2020-06-06 23:59:59",
        "createdAt": "2020-05-08 19:25:41",
        "title": "茶饮满二赠一券",
        "couponId": "5",
        "deletedAt": null,
        "sellerName": "奈雪の茶",
        "updatedAt": "2020-05-08 19:25:41",
        "couponType": 1
    },
    {
        "couponExplain": "<p>1.&nbsp;在有效期内，凭此券可在“奈雪点单”小程序外卖(机场店、奈雪梦工厂除外)购买任意茶饮或软欧包减免5元优惠</p><p>2.&nbsp;此券不可兑换现金，不设找零，优惠券抵扣金额不予积分</p><p>3.&nbsp;此券每单仅限使用一张，不得与其他优惠券同时使用</p><p>4.&nbsp;此券不适用于第三方外送服务</p><p>5.&nbsp;券面图片仅供参考，产品以实物为准</p>",
        "imageUrl": "https://images.qmai.cn/s23107/2019/12/04/fcb80e25ea8b39c1ac.jpg",
        "id": "6",
        "discountAmount": 5,
        "beginAt": "2020-05-08 00:00:00",
        "useTimeScope": "[{\"begin\":\"00:00:00\",\"end\":\"23:59:59\"}]",
        "endAt": "2020-06-06 23:59:59",
        "createdAt": "2020-05-08 19:25:40",
        "title": "小程序外卖5元现金券",
        "couponId": "6",
        "deletedAt": null,
        "sellerName": "奈雪の茶",
        "updatedAt": "2020-05-08 19:25:40",
        "couponType": 1
    }
]
